module.exports = __webpack_public_path__ + "img/Hotmart-1-en.c14bf986.png";